import { watch } from 'vue';
import { useTheme } from 'vuetify';
import { storeToRefs } from 'pinia';
import { useProjectConfigStore } from '@/stores/projectConfig';

/**
 * Ensures project config is loaded and applies palette to Vuetify theme.
 * Call this once at app root (e.g. App.vue).
 */
export function useProjectConfig() {
  const store = useProjectConfigStore();
  const theme = useTheme();
  const { logoUrl, palette, loading, error } = storeToRefs(store);

  watch(
    palette,
    (newPalette) => {
      if (!newPalette || Object.keys(newPalette).length === 0) return;
      const themes = theme.themes.value;
      for (const themeName of Object.keys(themes)) {
        const t = themes[themeName];
        if (t?.colors) {
          for (const [key, value] of Object.entries(newPalette)) {
            (t.colors as Record<string, string>)[key] = value;
          }
        }
      }
    },
    { immediate: true, deep: true }
  );

  return {
    logoUrl,
    palette,
    loading,
    error,
  };
}
